/** G18 legacy cutover. Deployed builds are read-only unless explicitly enabled. */
export function resolveLegacyAssessmentWrites(flag: string | undefined, mode: string): boolean {
  if (flag === 'true') return true
  if (flag === 'false') return false
  // Existing mutation component tests exercise pre-cutover behavior. Production
  // and development builds remain fail-closed when the variable is absent.
  return mode === 'test'
}

export const legacyAssessmentWritesEnabled = resolveLegacyAssessmentWrites(
  import.meta.env.VITE_LEGACY_ASSESSMENT_WRITES_ENABLED,
  import.meta.env.MODE
)

export const legacyAssessmentReadOnlyMessage =
  'Legacy assessment history is read-only. Continue work in the V2 return-preparation workspace.'
